module.exports = React.PropTypes;


//////////////////
// WEBPACK FOOTER
// external "React.PropTypes"
// module id = 1
// module chunks = 0 1 2 3 4 5 6 8 9 10 11 12